import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface NoContentConfig {
  src?: string;
  iconName?: string;
  srcset?: string;
  title: string;
  subtitle?: string;
  buttonText?: string;
}

@Component({
  selector: 'cm-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.scss'],
})
export class NoContentComponent {
  @Input()
  set config({ src, srcset, title, subtitle, iconName, buttonText }: NoContentConfig) {
    this.src = src;
    this.srcset = srcset;
    this.title = title;
    this.subtitle = subtitle;
    this.iconName = iconName;
    this.buttonText = buttonText;
  }
  @Output() public onButtonClick: EventEmitter<void> = new EventEmitter();

  public iconName: string;
  public src: string;
  public srcset: string;
  public title: string;
  public subtitle: string;
  public buttonText: string;
}
